<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">Style</p>
        <h1 class="dg-header">Logo</h1>
        <p>The official guidelines for using the State of Michigan's logo.</p>
      </div>
    </div>

      <div class="row content">
        <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
          <!-- Content -->
          <div class="row">
            <div class="col">
              <p class="h3 dg-subheader">Our Logo</p>
              <p><strong>ADD IMAGE</strong></p>   
               <p class="h4 mt-4">Logo Color</p>
              <p>If the logo is on a white background, use black logotype with the state outline and dot accent color of Hex #31A09D.</p>  
               <p><strong>ADD IMAGE</strong></p> 
               <p class="h6">Black and White Logo</p>
               <p>If you cannot use color, produce the logo in black. If the background is black, reverse the colors. If the logo is used on a color background, use either the white or black version that will produce the most contrast as an overlay.</p>
               <p><strong>ADD IMAGE</strong></p> 
               <p class="h4 mt-4">Logo Integrity</p>
                <p class="h6 mt-4">Logo Spacing</p>
                <p>Maintain clear space around the logo to protect the logo from distracting graphics or typography. As a general rule, measure a minimum buffer area with the letter 'O' in 'gov'.</p>
                <p><strong>WE NEED TO DISCUSS SEPARATING THE LOGO MARK FROM THE TYPE....ACCEPTABLE?</strong></p>
                <p><strong>WHAT IS A MI.GOV LOGO VS. A STATE OF MICHIGAN IDENTITY OR MARK?</strong></p>  
                <p><strong>IF WE ALLOW THE LOGO MARK TO BE SEPARATE FROM MI.GOV, WHAT ARE THE ASSOCIATED RULES FOR USE?</strong></p> 
               <p><strong>ADD IMAGE</strong></p>
               <p class="h6 mt-4">Minimum Size</p>
               <p>Never reproduce the logo smaller than 1.25 inches wide, measured from the left outermost tip of the U.P. to the right side edge of the 'v' in 'gov'.</p>
               <p><strong>ADD IMAGE</strong></p>
               <p class="h6 mt-4">Distortion</p>
               <p>Do not distort by manipulating the logo with a squeeze or stretch.</p>
               <p><strong>ADD IMAGE</strong></p>
               <p class="h6 mt-4">Insufficient Contrast</p>
               <p>Do not use backgrounds that provide insufficient contrast.</p>
               <p><strong>ADD IMAGE</strong></p>
               <p class="h6 mt-4">Authorized Artwork</p>
               <p>Only used authorized artwork from the State of Michigan branding authorities.</p>
            </div>
          </div>
          <!-- Content End -->
        </div>
      </div>

      <div class="row content">
        <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
          <!-- Content -->
          
          <!-- Content End -->
        </div>
      </div>

     
        
 
  </div>
  <!-- eslint-enable -->
</template>

<script>
export default {
  name: "Logo"
};
</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/Logo.vue